import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../utils/Header/Header";
import SideBar from "../utils/SideBar/SideBar";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { LMS_ROUTES, NOT_INCLUDE_HEDER_ROUTES } from "./constant";

const UserLayout = () => {
  const [isLoggedIn] = useState(localStorage.getItem("token"));

  const [hideSidebar, setHideSidebar] = useState(true);

  const mobileScreen = useMediaQuery({ query: `(max-width: 440px)` });

  const location = useLocation();
  const keepSidebarClosed =
    mobileScreen && location.state?.keepSidebarClosed === true;

  const isProfileCompleted = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const requiredFields = [
      "dob",
      "gender",
      // "lastName",
      "stateId",
      "userName",
      "firstName",
      "mobileNo",
      "districtId",
    ];

    if (!user) {
      return false;
    }

    if (
      user.userTypeId !== 7 &&
      user.userTypeId !== 11 &&
      user.userTypeId !== 12 && 
      user.userTypeId !== 8
    ) {
      requiredFields.push("schoolId");
    }

    return requiredFields.every((field) => user[field]);
  };

  useEffect(() => {
    if (mobileScreen) {
      // you don't need return statement here.
      setHideSidebar(false);
    }
  }, [mobileScreen]);

  useEffect(() => {
    if (keepSidebarClosed) {
      setHideSidebar(false);
    }
  }, [keepSidebarClosed]);

  if (!isLoggedIn) {
    return <Navigate to="/user/language" />;
  }

  return (
    <>
      <div className="grid  md:grid-cols-4 lg:grid-cols-5 h-screen overflow-x-hidden">
       {!NOT_INCLUDE_HEDER_ROUTES.includes(location.pathname) ? <SideBar
          hsidebar={hideSidebar}
          tsidebar={{ hideSidebar, setHideSidebar }}
          isUserProfileCompleted={isProfileCompleted()}
          keepSidebarClosed={keepSidebarClosed}
        />:null}
        <div
          className={`${
            hideSidebar
              ? "md:col-span-3 lg:col-span-4 md:block h-screen hidden"
              : "col-span-5 overflow-hidden"
          }`}
        >
          {isProfileCompleted() === true ? (
            !LMS_ROUTES.includes(location.pathname)
            ?
            <Header tsidebar={{ hideSidebar, setHideSidebar }} 
            />
            :null
          ) : (
            <></>
          )}

          <Outlet />
        </div>
      </div>
    </>
  );
};

export default UserLayout;
